import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { type TTgbNativedescGeneralContext } from '@cian/adfox-templates';

import { INewbuildingInfoForTgbSchema } from '../../../../../../types/adfox';

import type { TTgbNativedescGeneralProps } from '../components/TgbNativedescGeneralNarrow';

type TGetTgbNativedescGeneralNarrowPropsParams = {
  context: TTgbNativedescGeneralContext;
  newbuidingInfoForTgb: null | INewbuildingInfoForTgbSchema;
  sizes: TAdFoxBannerCompleteSizes;
};

export function getTgbNativedescGeneralNarrowProps({
  sizes,
  context: { url, label, image, title, annotation, description, logoImageUrl, mortgageTermsWarning, mortgageWarning },
  newbuidingInfoForTgb,
}: TGetTgbNativedescGeneralNarrowPropsParams): TTgbNativedescGeneralProps {
  const tgbNativedescGeneralProps = {
    annotation,
    description,
    image,
    label,
    logoUrl: logoImageUrl,
    title,
    url,
    mortgageTermsWarning,
    mortgageWarning,
    sizes,
  };

  if (newbuidingInfoForTgb) {
    Object.assign<TTgbNativedescGeneralProps, Partial<TTgbNativedescGeneralProps>>(tgbNativedescGeneralProps, {
      logoUrl: newbuidingInfoForTgb.publisher.logo.url,
    });
  }

  return tgbNativedescGeneralProps;
}
